import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=620c5265&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=620c5265&prod&lang=less&scoped=true"
import style1 from "./Home.vue?vue&type=style&index=1&id=620c5265&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620c5265",
  null
  
)

export default component.exports